import { HttpInterceptorFn } from '@angular/common/http';
import { trimObject, trimValue } from '../utils/string';

export const trimInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.body instanceof FormData) {
    const trimmed = new FormData();
    req.body.forEach((value, key) => {
      trimmed.append(key, trimValue(value));
    });
    req = req.clone({ body: trimmed });
  } else if (req.body && typeof req.body === 'object') {
    req = req.clone({ body: trimObject(req.body as Record<string, unknown>) });
  }
  return next(req);
};
